const PARAGRAPH_PODCAST = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on Promotion {
      id
      title
      type
      uuid
      body
      displayLogo
      featuredImage {
        alt
        promotionBlockLandscape
        promotionBlockLandscapeMedium
        smallPromotionBlockLandscape
        url
      }
      buttonPromotion {
        color
        title
        url
      }
    }
  }
`;

export default PARAGRAPH_PODCAST;
